import { PaymentsListItem } from './payments-list.interfaces';

export function parsePaymentsList(payments): Array<PaymentsListItem> {
  return payments.map((payment: PaymentsListItem) => {
    payment.date = new Date(payment.date);
    return payment;
  });
}
